import script from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=4c03779a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c03779a"]])

export default __exports__